import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/style.css'
import * as moment from 'moment/moment'
import ElementUI from 'element-ui'
import './assets/etheme/element-variables.scss'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'


Vue.use(ElementUI)
moment.locale('zh-cn');
Vue.prototype.$moment = moment




new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
